<template lang="pug">
span.root
	aside.checkbox
		input(type="checkbox" :id="data.id" v-model="model")
		label(:for="data.id") {{ data.value }}

</template>

<script>
export default {
	name: "CaroFilterCheckbox",
	props: {
		data: Object,
		setFilterValue: Function,
	},
	data() {
		return {};
	},
	computed: {
		model: {
			get() {
				return this.data.selected;
			},
			set(value) {
				this.setFilterValue(this.data, value);
			},
		},
	},
};
</script>


<style lang="scss" scoped>
span.root {
	display: contents;
}
aside {
	padding-bottom: 1.25rem;
}

.checkbox {
	position:relative;
	label {
		position:relative;
		color: #41535D;
		padding: .25rem 0 0 2.5rem;

		&:before {
			background: #ffffff;
			content: "";
			height: 1.25rem;
			width: 1.25rem;
			left: 0;
			position: absolute;
			top: 1px;
			border: 1px solid #45545F;
		}
		&:after {
			border-bottom: 2px solid #fff;
			border-right: 2px solid #fff;
			content: "";
			height: 12px;
			width: 6px;
			top: 3px;
			left: 7px;
			position: absolute;
			transform: rotate(40deg);
			opacity: 0;
			filter: alpha(opacity=0);
		}
	}
}
.checkbox input[type="checkbox"]{
	cursor: pointer;
	position:absolute;
	width:100%;
	height:100%;
	z-index: 1;
	opacity: 0;
	filter: alpha(opacity=0);
}
//.checkbox input[type="checkbox"]:hover + label:after{
//	opacity: 1;
//	filter: alpha(opacity=100);
//	border-color:#999;
//}
//.modal-1 .checkbox input[type="checkbox"]:hover + label:after{
//	border-color:#fff;
//}
.checkbox input[type="checkbox"]:checked + label:after,
.checkbox input[type="checkbox"]:checked + label:before{
	opacity: 1;
	filter: alpha(opacity=100);
}
.checkbox input[type="checkbox"]:checked + label:before{
	background: #007C89;
}
</style>
